import React, { Suspense, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AxiosInstance from 'utils/AxiosInstance'
import { Card, Container } from 'reactstrap'
import { CourseDetails } from '../LearningPlan'
import '../LearningPlan/style.css'
import {
  progress,
  fetchCourses,
  fetchUserProgress,
  onSearchReset,
} from 'store/Course/actions'
import {
  toggleGroupOrder,
  fetchGroups,
  fetchGroupsCourses,
  setIndividualCourses,
  fetchUserGroupProgress,
} from 'store/Group/actions'
import { reset } from 'store/Preloader/actions'
import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { getExemptCourses } from 'store/EmployeeReport/actions'
import Loader from '../Loader'
import { useHistory, useLocation } from 'react-router'
import { setLastPathname } from 'store/Course/actions'

const LazySlider = React.lazy(() => import('../LearningPlan/Slider'))

const Development = (props) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [groups, setGroups] = useState([])
  const coursesState = useSelector((state) => state.courses)
  const courseConfig = useSelector((state) => state.courseConfig)
  const groupState = useSelector((state) => state.groups)
  const { user } = useSelector((state) => state.auth)
  const employeeReport = useSelector((state) => state.employeeReport)

  const location = useLocation()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setLastPathname(location.pathname))
  }, [])

  useEffect(() => {
    if (!coursesState.courses.length) {
      dispatch(fetchUserProgress())
      dispatch(fetchGroups())
      dispatch(fetchCourses())
      dispatch(setIndividualCourses())
      dispatch(fetchCourseSettings())
    }

    if (!coursesState.progress.length) {
      dispatch(progress())
    }

    if (!groupState.groupsCourses.length) {
      dispatch(fetchGroupsCourses())
    }

    if (groupState.groupOrderShowing) {
      dispatch(toggleGroupOrder())
    }

    if (groupState.learningPlanGroups.length) {
      dispatch(fetchUserGroupProgress())
    }

    const { progressLoaded } = groupState
    dispatch(reset(progressLoaded))
    dispatch(getExemptCourses(user.id))

    setLoading(true)
    AxiosInstance.get('/groups/pinned_development')
      .then((response) => {
        if (response.pinnedGroups) {
          setGroups(response.pinnedGroups)
        } else {
          setError(response.message)
        }

        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
    return () => {
      dispatch(onSearchReset())
    }
  }, [])

  const filteredGroups = groupState.groups.filter(
    (item) => item.type === 'course' && groups.includes(item.id)
  )

  return (
    <Container className='mt--6' fluid>
      <Card className='mt--6 py-4 px-3' style={{ minHeight: '85vh' }}>
        {loading ? (
          <div
            className='dFlex justifyCenter itemsCenter textCenter'
            style={{ minHeight: '80vh' }}
          >
            <Loader />
          </div>
        ) : (
          <div style={{ minHeight: '80vh' }}>
            <Suspense
              fallback={
                <div
                  className='dFlex justifyCenter itemsCenter textCenter'
                  style={{ minHeight: '80vh' }}
                >
                  <Loader />
                </div>
              }
            >
              {filteredGroups.length === 0 ? (
                <div
                  className='dFlex justifyCenter itemsCenter textCenter'
                  style={{ minHeight: '80vh' }}
                >
                  <p className='text-primary blockquote font-weight-normal'>
                    No data here
                  </p>
                </div>
              ) : (
                filteredGroups.map((group) => {
                  const groupCourses = (
                    groupState.groupsCourses[group.id] || []
                  ).map((item) => item.course_id)

                  let courses = []

                  groupCourses.forEach(
                    (id) =>
                      (courses = [
                        ...courses,
                        ...coursesState.progress.filter(
                          (course) => course.id === id
                        ),
                      ])
                  )
                  courses = courses.filter(
                    (item) =>
                      !employeeReport.exemptCourses.find(
                        (exemptCourse) => exemptCourse.course_id === item.id
                      )
                  )

                  if (groupCourses.length && !courses.length) {
                    return null
                  }

                  return (
                    <LazySlider
                      key={group.id}
                      sectionTitle={group.name}
                      id={group.id}
                      inactive={group.inactive}
                      access={user.access}
                    >
                      {courses.length > 0 ? (
                        courses.map((item, courseIndex) => (
                          <CourseDetails
                            courseState={coursesState}
                            key={item.course_id}
                            course={item}
                            user={user}
                            courseIndex={courseIndex}
                            courseConfig={courseConfig}
                          />
                        ))
                      ) : (
                        <p className='text-primary blockquote font-weight-normal'>
                          No data here
                        </p>
                        // <Loader />
                      )}
                    </LazySlider>
                  )
                })
              )}
            </Suspense>

            {error && (
              <div
                className='dFlex justifyCenter itemsCenter textCenter'
                // style={{ minHeight: '60vh' }}
              >
                {/* <p className='text-primary blockquote font-weight-normal'>
                  {error}
                </p> */}
              </div>
            )}
          </div>
        )}
      </Card>
    </Container>
  )
}

export default Development
